<nb-alert outline="warning" *ngIf="(buildIsUpToDate$ | async) === false">
  <div class="d-flex justify-content-between">
    <span translate="build.banner" class="my-auto"></span>
    <button nbButton (click)="reload()" class="float-right" size="small">
      <nb-icon icon="refresh-outline"></nb-icon>
      <span translate="build.reload"></span>
    </button>
  </div>
</nb-alert>
